import moment from "moment";

const isQrCodeExpired = date => {
  const adjustedUTC = moment(date).subtract(3, "hours");

  return moment(adjustedUTC).diff(new Date(), "minutes") + 1;
};

export default isQrCodeExpired;
